import FlyoutTabsContainer from './FlyoutTabsContainer';

export default FlyoutTabsContainer;
